<template>
  <MultipleSelect
    ref="multipleSelect"
    v-bind="$attrs"
    multiple="multiple"
    class="multple-select-jquery form-control"
    v-on="$listeners"
  >
    <slot />
  </MultipleSelect>
</template>

<script>
/* global MultipleSelect */
import 'multiple-select/dist/multiple-select.js'
import 'multiple-select/dist/multiple-select-vue'

export default {
  components: {
    MultipleSelect: MultipleSelect
  },
  methods: {
    close() {
      this.$refs.multipleSelect?.close();
    }
  }
}
</script>
